import { TruckFullIcon } from '@/domains/core/tamagoshiTailwind/icons/TruckFullIcon';
import { Gtm } from '@/domains/core/tracking/utils/Gtm';
import { useFacet } from '@/domains/productDiscovery/Listings/facets/hooks/useFacet';
import { useCategoryFamilyId } from '@/domains/productDiscovery/Listings/pages/Category/hooks/useCategoryFamilyId';
import { useCategoryId } from '@/domains/productDiscovery/Listings/pages/Category/hooks/useCategoryId';
import { useCategoryLevel } from '@/domains/productDiscovery/Listings/pages/Category/hooks/useCategoryLevel';

import { QuickFilterButton } from '../QuickFilterButton/QuickFilterButton';
import { freeDelivery } from './translations';

export const QuickFreeDeliveryFilter = () => {
  const categoryId = useCategoryId();
  const categoryLevel = useCategoryLevel();
  const categoryFamilyId = useCategoryFamilyId();

  const { facet, refineFacetValue } = useFacet<'bool'>('has_free_delivery');

  const freeDeliveryValue = (facet?.values?.filter(
    (el) => el.name === 'true',
  ) || [])[0];
  if (!freeDeliveryValue) return null;

  const handleClick = async () => {
    const { generateFiltersTracking } = await import(
      '@/domains/productDiscovery/Listings/components/Filters/tracking/generateFiltersTracking'
    );

    Gtm.push(
      generateFiltersTracking({
        e_label: freeDeliveryValue.name,
        filter_id: 'free_delivery',
        filter_name: freeDeliveryValue.name,
        filter_value: !freeDeliveryValue.isRefined,
        filter_position: 0,
        filter_count: 1,
        is_quick_filter: true,
        category_id: categoryId,
        category_level: categoryLevel,
        family_id: categoryFamilyId,
      }),
    );
    refineFacetValue(!freeDeliveryValue.isRefined);
  };

  return (
    <QuickFilterButton
      icon={TruckFullIcon}
      onClick={handleClick}
      text={freeDelivery.label}
      active={freeDeliveryValue.isRefined}
    />
  );
};

QuickFreeDeliveryFilter.displayName = 'QuickFreeDeliveryFilter';
